'use client';

import { c as _c } from "react/compiler-runtime";
import { Card } from '@morpho-org/ui-v6/server';
import { type ReactNode, useState } from 'react';
import { useIsMedium } from '@/hooks/useBreakpoints';
import { trackMarketRateModeChanged } from '@/lib/analytics/client/trackers/market-lend';
import type { MarketApyCardData } from './MarketApyCard.mapper';
import { ApyCardMarketRateModeProvider, type MarketApyRateMode } from './ApyCardMarketRateMode.context';
import RateCardMarket from './RateCardMarket';
export interface ApyCardMarketClientProps {
  market: MarketApyCardData;
  chartApySlot: ReactNode;
}

/**
 * Apy Card component to display the chart and all the rates for the market
 * With responsive logic design for mobile and desktop
 */
const ApyCardMarketClient = t0 => {
  const $ = _c(16);
  const {
    market,
    chartApySlot
  } = t0;
  const isMedium = useIsMedium();
  const [rateMode, setRateMode] = useState("borrow");
  const {
    marketId,
    chainId
  } = market;
  let t1;
  if ($[0] !== chainId || $[1] !== marketId || $[2] !== rateMode) {
    t1 = mode => {
      if (mode === rateMode) {
        return;
      }
      setRateMode(mode);
      trackMarketRateModeChanged({
        marketId,
        chainId,
        rateMode: mode
      });
    };
    $[0] = chainId;
    $[1] = marketId;
    $[2] = rateMode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== rateMode || $[5] !== t1) {
    t2 = {
      rateMode,
      setRateMode: t1
    };
    $[4] = rateMode;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const rateModeValue = t2;
  let t3;
  if ($[7] !== market) {
    t3 = <RateCardMarket market={market} />;
    $[7] = market;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const rateCard = t3;
  let t4;
  if ($[9] !== chartApySlot || $[10] !== isMedium || $[11] !== rateCard) {
    t4 = isMedium ? <div className="gap-sm flex w-full flex-col"><Card className="py-lg px-md" withBorder={true}>{chartApySlot}</Card><Card className="py-lg px-md flex-col" withBorder={true}>{rateCard}</Card></div> : <Card className="gap-lg" padding="m" withBorder={true}>{chartApySlot}{rateCard}</Card>;
    $[9] = chartApySlot;
    $[10] = isMedium;
    $[11] = rateCard;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== rateModeValue || $[14] !== t4) {
    t5 = <ApyCardMarketRateModeProvider value={rateModeValue}>{t4}</ApyCardMarketRateModeProvider>;
    $[13] = rateModeValue;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default ApyCardMarketClient;